/* KS cart size switch (October 2026, round 2).
   Handles the "Switch to 100g" button that snippets/ks-cart-upsize.liquid
   puts on a cart line. It adds one of the bigger size, then removes the
   smaller line, and hands the new cart to the theme the same way the
   theme's own quantity buttons do, so the drawer, the cart count and the
   free shipping bar all update. On the cart page it reloads the page, as
   the theme does. If anything fails, the cart is simply refreshed. */
(() => {
  if (window.ksCartUpsize) return;
  window.ksCartUpsize = true;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const fire = (name, detail) =>
    document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-ks-upsize]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;

    event.preventDefault();
    button.setAttribute('aria-busy', 'true');
    fire('theme:loading:start');

    try {
      const added = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
      });
      if (!added.ok) throw new Error('add failed');

      const sections = [];
      fire('cart:prepare-bundled-sections', { sections });

      const changed = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: button.dataset.lineKey, quantity: 0, sections: sections.join(',') })
      });
      if (!changed.ok) throw new Error('remove failed');

      const cart = await changed.json();
      fire('theme:loading:end');

      if (window.themeVariables && window.themeVariables.settings.pageType === 'cart') {
        window.location.reload();
        return;
      }

      fire('cart:change', { baseEvent: 'line-item:change', cart });
    } catch (error) {
      fire('theme:loading:end');
      button.removeAttribute('aria-busy');
      fire('cart:refresh');
    }
  });
})();
